import React, { useEffect, createElement } from 'react';
export function Modulo2Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1695">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1696">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1697">
          AI <span className="text-[#F5C842]" data-id="element-1698">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1699">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1700">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1701">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1702">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1703">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1704">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1705">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1706">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1707">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1708">
            Módulo 2 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1709">
            ⏱ 20 minutos · Herramienta: Ai Website Arbitrage
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1710">
          El Cerebro
          <br data-id="element-1711" />
          <span className="text-[#F5C842]" data-id="element-1712">Cazador</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1713">
          Cómo usar el cerebro de IA "Ai Website Arbitrage" para encontrar 10
          prospectos perfectos en menos de 15 minutos — sin buscar manualmente.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1714">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1715">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1716"></div>
            Herramienta: Ai Website Arbitrage en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1717">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1718"></div>4
            filtros del prospecto ideal
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1719">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1720"></div>
            Lista de 5 prospectos listos para contactar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1721">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-1722">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1723">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1724"></span>
            Video del Módulo
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1725">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1726">
              <iframe src="https://player.vimeo.com/video/1179701651?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 2" data-id="element-1727" />
            </div>
          </div>
        </div>

        {/* BUTTON MODULO 2 */}
        <div className="mt-4 mb-10" data-id="element-1728">
          <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1729">
            <span className="text-[20px]" data-id="element-1730">🧠</span>
            Abrir Ai Website Arbitrage en Heylloyd
            <span className="text-[18px] font-black" data-id="element-1731">→</span>
          </a>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black p-7" data-id="element-1732">
          <div className="text-[48px] leading-none shrink-0" data-id="element-1733">🧠</div>
          <div data-id="element-1734">
            <div className="mb-1.5 text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1735">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-1736">
              Ai Website Arbitrage
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-1737">
              La IA personalizada que escanea el mercado local y te entrega una
              lista de negocios sin sitio web o con sitios obsoletos. Solo le
              dices el tipo de negocio y la ciudad — ella hace todo el trabajo
              de investigación en segundos.
            </div>
          </div>
        </div>

        {/* HOW TO USE STEPS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1738">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1739"></span>
          Cómo Usar Ai Website Arbitrage
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3.5 md:grid-cols-4" data-id="element-1740">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1741">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1742">
              1
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1743">
              Abre HEYLLOYD
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1744">
              Accede a tu cuenta y selecciona el cerebro "Ai Website Arbitrage"
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1745">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1746">
              2
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1747">
              Ingresa el nicho
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1748">
              Escribe el tipo de negocio (ej: "peluquerías", "restaurantes",
              "talleres")
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1749">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1750">
              3
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1751">
              Ingresa la ciudad
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1752">
              Escribe tu ciudad o la ciudad donde quieres conseguir clientes
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1753">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1754">
              4
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1755">
              Analiza los resultados
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1756">
              La IA te entrega nombre, teléfono y estado del sitio web de cada
              negocio
            </div>
          </div>
        </div>

        {/* FILTERS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1757">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1758"></span>
          Los 4 Filtros del Prospecto Ideal
        </div>
        <div className="mb-8 grid grid-cols-1 gap-3 md:grid-cols-2" data-id="element-1759">
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1760">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1761">
              ✓
            </div>
            <div data-id="element-1762">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1763">
                Sin sitio web
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1764">
                La señal más clara de oportunidad. Si no tienen sitio, ya saben
                que lo necesitan — solo falta que alguien se los ofrezca.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1765">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1766">
              ✓
            </div>
            <div data-id="element-1767">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1768">
                Sitio con más de 3 años
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1769">
                Un sitio viejo es casi tan malo como no tener. El dueño sabe que
                está desactualizado y está abierto a mejorarlo.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1770">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1771">
              ✓
            </div>
            <div data-id="element-1772">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1773">
                Buenas reseñas en Google
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1774">
                Significa que ya tienen clientes reales y están activos. Un
                sitio web para ellos es una inversión, no un gasto.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1775">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1776">
              ✓
            </div>
            <div data-id="element-1777">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1778">
                Negocio físico con dirección
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1779">
                Negocios físicos tienen más urgencia de aparecer en búsquedas
                locales de Google que negocios 100% online.
              </div>
            </div>
          </div>
        </div>

        {/* WHAT TO SAVE */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1780">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1781">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1782">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1783"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1784">
                Datos que debes guardar de cada prospecto
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1785">
              <ul className="flex flex-col" data-id="element-1786">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1787">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1788">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1789">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1790">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1791">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1792">Nombre del dueño</strong> (si
                  aparece en Google)
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1793">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1794">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1795">Teléfono / WhatsApp</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1796">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1797">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1798">Estado del sitio</strong> — sin
                  sitio o sitio viejo
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1799">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1800">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1801">Número de reseñas</strong> en
                  Google
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1802">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1803">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1804">Por qué lo elegiste</strong> —
                  tu razón de contacto
                </li>
              </ul>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1805">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1806">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1807"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1808">
                Por qué las buenas reseñas son clave
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1809">
              Un negocio con buenas reseñas ya tiene clientes. Ya están ganando
              dinero. Un sitio web para ellos{' '}
              <strong className="text-white" data-id="element-1810">
                no es un gasto, es una inversión
              </strong>{' '}
              que les va a traer más clientes.
              <br data-id="element-1811" />
              <br data-id="element-1812" />
              Eso hace que la conversación de venta sea completamente diferente.
              No estás convenciéndolos de gastar — estás mostrándoles cómo{' '}
              <strong className="text-white" data-id="element-1813">ganar más</strong>.
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-1814">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1815">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1816"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1817">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1818">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1819"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1820">
              "Bienvenido al Módulo 2. Aquí es donde la magia empieza. Voy a
              mostrarte cómo usar el cerebro de IA{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1821">
                'Ai Website Arbitrage'
              </span>{' '}
              para encontrar 10 prospectos perfectos en menos de 15 minutos.
              Abre el software y sígueme."
            </div>
          </div>

          <div className="mb-4" data-id="element-1822">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1823">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1824"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1825">
              "Primero, abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1826">
                'Ai Website Arbitrage'
              </span>{' '}
              en HEYLLOYD. Vas a ver una pantalla que te pide dos cosas: el tipo
              de negocio y la ciudad. Escribe, por ejemplo,{' '}
              <span className="not-italic text-[#666]" data-id="element-1827">'peluquerías'</span> y{' '}
              <span className="not-italic text-[#666]" data-id="element-1828">'Miami'</span>. Ahora
              observa lo que hace."
              {'\n\n'}
              "El cerebro analiza los resultados de Google Maps y te da una
              lista de negocios con su nombre, dirección, teléfono y, lo más
              importante, si tienen sitio web o no. También te dice si el sitio
              que tienen es moderno o está desactualizado."
              {'\n\n'}
              "De esta lista, quiero que identifiques los 5 mejores prospectos.
              Los mejores son los que: no tienen sitio web, tienen un sitio con
              más de 3 años de antigüedad, tienen buenas reseñas en Google (lo
              que significa que tienen clientes reales y están activos), y son
              negocios físicos con una dirección real."
              {'\n\n'}
              "¿Por qué estos criterios? Porque un negocio con buenas reseñas ya
              tiene clientes. Ya están ganando dinero. Un sitio web para ellos
              no es un gasto, es una inversión que les va a traer más clientes.
              Eso hace que la venta sea mucho más fácil."
            </div>
          </div>

          <div className="mb-4" data-id="element-1829">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1830">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1831"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1832">
              "Tu tarea: usa el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1833">
                'Ai Website Arbitrage'
              </span>{' '}
              y encuentra tus 5 mejores prospectos. Guarda su nombre, teléfono y
              por qué los elegiste. En el Módulo 3, vamos a construir una demo
              de su sitio web antes de hablar con ellos. Eso es lo que hace que
              esta venta sea diferente a cualquier otra."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1834">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1835">
            ✅ Tu Tarea — Módulo 2
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1836">
            Usa <strong className="text-white" data-id="element-1837">Ai Website Arbitrage</strong> en
            HEYLLOYD y encuentra tus{' '}
            <strong className="text-white" data-id="element-1838">5 mejores prospectos</strong>. No
            pases al Módulo 3 sin completar esta tarea.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1839">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1840">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1841">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Ai Website Arbitrage"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1842">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1843">
                  2
                </div>
                Ingresa el tipo de negocio y tu ciudad
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1844">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1845">
                  3
                </div>
                Aplica los 4 filtros del prospecto ideal para seleccionar los
                mejores
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1846">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1847">
                  4
                </div>
                Guarda nombre, teléfono y razón de selección de cada uno
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1848">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1849">
                  5
                </div>
                <strong className="text-white" data-id="element-1850">
                  Selecciona tus 5 mejores prospectos y pasa al Módulo 3
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1851">
        <a href="/modulo-1" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] no-underline transition-colors hover:text-white" data-id="element-1852">
          ← Módulo 1
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1853">
          AI <span className="text-[#F5C842]" data-id="element-1854">WEB CLOSER</span>
        </div>
        <a href="/modulo-3" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1855">
          Módulo 3: La Demo que Cierra Sola →
        </a>
      </div>
    </div>;
}